// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__O-SB1","input":"Checkbox_input__KAVVD","checkmark":"Checkbox_checkmark__H3nN5","disabled":"Checkbox_disabled__h5VEk","radio":"Checkbox_radio__uIYt9"};